import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ImpactMetrics = () => {
  const [animatedValues, setAnimatedValues] = useState({
    students: 0,
    placement: 0,
    salary: 0,
    partners: 0,
    projects: 0,
    countries: 0
  });

  const finalValues = {
    students: 5247,
    placement: 95,
    salary: 85,
    partners: 247,
    projects: 1834,
    countries: 23
  };

  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    const intervals = Object.keys(finalValues).map(key => {
      const increment = finalValues[key] / steps;
      let currentValue = 0;
      
      return setInterval(() => {
        currentValue += increment;
        if (currentValue >= finalValues[key]) {
          currentValue = finalValues[key];
          clearInterval(intervals.find(interval => interval === this));
        }
        
        setAnimatedValues(prev => ({
          ...prev,
          [key]: Math.floor(currentValue)
        }));
      }, stepDuration);
    });

    return () => intervals.forEach(clearInterval);
  }, []);

  // const metrics = [
  //   {
  //     icon: "Users",
  //     value: animatedValues.students,
  //     suffix: "+",
  //     label: "Students Transformed",
  //     description: "Lives changed through our programs",
  //     color: "accent",
  //     trend: "+23% this year"
  //   },
  //   {
  //     icon: "TrendingUp",
  //     value: animatedValues.placement,
  //     suffix: "%",
  //     label: "Job Placement Rate",
  //     description: "Within 6 months of graduation",
  //     color: "success",
  //     trend: "Industry leading"
  //   },
  //   {
  //     icon: "DollarSign",
  //     value: animatedValues.salary,
  //     suffix: "%",
  //     label: "Average Salary Increase",
  //     description: "Compared to pre-program income",
  //     color: "warning",
  //     trend: "$75K average"
  //   },
  //   {
  //     icon: "Building2",
  //     value: animatedValues.partners,
  //     suffix: "+",
  //     label: "Partner Companies",
  //     description: "Hiring our graduates",
  //     color: "cyber-purple",
  //     trend: "Fortune 500 included"
  //   },
  //   {
  //     icon: "Code",
  //     value: animatedValues.projects,
  //     suffix: "+",
  //     label: "Projects Completed",
  //     description: "Real-world applications built",
  //     color: "accent",
  //     trend: "Production ready"
  //   },
  //   {
  //     icon: "Globe",
  //     value: animatedValues.countries,
  //     suffix: "+",
  //     label: "Countries Reached",
  //     description: "Global community impact",
  //     color: "success",
  //     trend: "Growing daily"
  //   }
  // ];

  const achievements = [
    {
      year: "2025",
      title: "VEX IQ Excellence Award",
      organization: "VEX",
      description: "Won the VEX IQ Nationals in India"
    },
    {
      year: "2025",
      title: "WSRO Regionals 2025 - Young Scientist Energy Sr.",
      organization: "TWSRO",
      description: "Our team won in the Young Scientist Energy Sr. category at the TWSRO Regionals 2025"
    },
    {
      year: "2025",
      title: "WSRO Regionals 2025 - Young Scientist Energy Algorithms",
      organization: "WSRO",
      description: "3 of our teams won in the Young Scientist Energy Algorithms category at the WSRO Regionals 2025"
    },
    {
      year: "2025",
      title: "WSRO Regionals 2025 - Junior Robo Race",
      organization: "WSRO",
      description: "2 of our teams won in the Junior Robo Race category at the WSRO Regionals 2025"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        {/* <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-6">
            <Icon name="BarChart3" size={16} className="text-accent mr-2" />
            <span className="text-sm font-medium text-accent">Real Impact</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            Measurable Transformation
          </h2>
          
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Numbers tell our story. Every metric represents real people whose lives have been transformed through technology education and community support.
          </p>
        </div> */}

        {/* Metrics Grid */}
        {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {metrics.map((metric, index) => (
            <div key={index} className="holographic-card p-8 text-center group hover:scale-105 transition-all duration-300">
              <div className={`w-16 h-16 bg-gradient-to-br from-${metric.color} to-${metric.color} rounded-full flex items-center justify-center mx-auto mb-6 shadow-glow group-hover:shadow-glow-strong transition-all duration-300`}>
                <Icon name={metric.icon} size={24} color="white" strokeWidth={2.5} />
              </div>
              
              <div className="text-4xl font-bold text-foreground mb-2">
                {metric.value.toLocaleString()}{metric.suffix}
              </div>
              
              <h3 className="text-lg font-semibold text-foreground mb-2">{metric.label}</h3>
              <p className="text-sm text-muted-foreground mb-4">{metric.description}</p>
              
              <div className={`inline-flex items-center px-3 py-1 rounded-full bg-${metric.color}/10 border border-${metric.color}/20`}>
                <Icon name="TrendingUp" size={12} className={`text-${metric.color} mr-1`} />
                <span className={`text-xs font-medium text-${metric.color}`}>{metric.trend}</span>
              </div>
            </div>
          ))}
        </div> */}

        {/* Success Stories Highlight */}
        {/* <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 md:p-12 border border-border mb-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
                Real Stories, Real Impact
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-accent to-success flex items-center justify-center flex-shrink-0">
                    <Icon name="Quote" size={20} color="white" />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-2">
                      "From retail worker to AI engineer at Google. DCC didn't just teach me to code—they taught me to dream bigger."
                    </p>
                    <div className="text-sm font-medium text-foreground">Maria Santos, AI Engineer @ Google</div>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyber-purple to-warning flex items-center justify-center flex-shrink-0">
                    <Icon name="Quote" size={20} color="white" />
                  </div>
                  <div>
                    <p className="text-muted-foreground mb-2">
                      "Our partnership with DCC transformed our entire engineering team. The quality of graduates is exceptional."
                    </p>
                    <div className="text-sm font-medium text-foreground">David Kim, CTO @ TechCorp</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-success mb-2">4.9/5</div>
                <div className="text-sm text-muted-foreground">Student Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-2">92%</div>
                <div className="text-sm text-muted-foreground">Would Recommend</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-cyber-purple mb-2">6 Months</div>
                <div className="text-sm text-muted-foreground">Avg. Job Timeline</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-warning mb-2">150%</div>
                <div className="text-sm text-muted-foreground">ROI for Companies</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Awards & Recognition */}
        <div>
          <h3 className="text-2xl font-bold text-foreground text-center mb-12">Awards & Recognition</h3>
          
          <div className="grid md:grid-cols-2 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="flex items-start space-x-6 p-6 rounded-xl bg-card/50 border border-border hover:bg-card/80 transition-colors duration-300">
                <div className="w-16 h-16 bg-gradient-to-br from-accent to-cyber-purple rounded-full flex items-center justify-center flex-shrink-0 shadow-glow">
                  <Icon name="Award" size={24} color="white" />
                </div>
                
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <span className="text-sm font-bold text-accent">{achievement.year}</span>
                    <div className="w-1 h-1 bg-muted-foreground rounded-full"></div>
                    <span className="text-sm text-muted-foreground">{achievement.organization}</span>
                  </div>
                  
                  <h4 className="text-lg font-semibold text-foreground mb-2">{achievement.title}</h4>
                  <p className="text-sm text-muted-foreground">{achievement.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactMetrics;